export default {"src":"/_next/static/media/due-tomorrow.7e6eb89f.svg","height":513,"width":513};